export default __webpack_public_path__ + "2178a98db26b91c07fc3013e04ed56b2.png";